// extracted by mini-css-extract-plugin
export default {"root":"Unsubscribe_root__aqICs","card":"Unsubscribe_card__na37p","title":"Unsubscribe_title__fI5wx","message":"Unsubscribe_message__EZluX","button":"Unsubscribe_button__lC1HO"};